"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _millisecondsToDuration = _interopRequireDefault(require("../../../../utils/time/millisecondsToDuration"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _spacing = _interopRequireDefault(require("../../../../constants/spacing"));

var _zIndex = _interopRequireDefault(require("../../../../constants/z-index"));

var _vars = _interopRequireDefault(require("../../../../constants/vars"));

var _colors = _interopRequireDefault(require("../../../../constants/colors"));

var _getBoundedValue = _interopRequireDefault(require("../../../../utils/numbers/getBoundedValue"));

var _OutlineButton = _interopRequireDefault(require("../../../Button/OutlineButton"));

var _reactGa = require("react-ga");

var _BrandButton = _interopRequireDefault(require("../../../Button/BrandButton"));

var _roundTo = _interopRequireDefault(require("../../../../utils/roundTo"));

var _durationToMilliseconds = _interopRequireDefault(require("../../../../utils/time/durationToMilliseconds"));

var _UnitInput = _interopRequireDefault(require("./UnitInput"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\tfont-size: 12px;\n\tmargin: -6px 0 0 0;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\tfont-family: ", ";\n\tfont-size: 16px;\n\tline-height: 22px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: block;\n\tflex: 1 0 100%;\n\tmargin: 0;\n\tpadding: 0;\n\ttext-align: center;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tflex: 1;\n\tdisplay: flex;\n\talign-content: center;\n\tflex-wrap: wrap;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tborder-top: 1px solid #0a223333;\n\tmargin: 0;\n\tpadding: ", ";\n\tjustify-content: space-between;\n\tflex-wrap: no-wrap;\n\tflex: 1 1 33%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tflex-direction: row;\n\tbackground-color: white;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: ", " ", " ", " ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\ttop: 50px;\n\theight: 322px;\n\tz-index: ", ";\n\twidth: 320px;\n\tbox-shadow: ", ";\n\tborder: 2px solid ", ";\n\tborder-radius: ", ";\n\tbackground-color: #fafdff;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Overlay = _styledComponents.default.div(_templateObject(), _zIndex.default.OVERLAY, _vars.default.boxShadow, _colors.default.borderFocus, _vars.default.borderRadius);

Overlay.displayName = 'Overlay';

var Content = _styledComponents.default.div(_templateObject2(), _spacing.default.s1, _spacing.default.s2, _spacing.default.s2, _spacing.default.s2);

Content.displayName = 'Content';

var DialogButtonGroup = _styledComponents.default.div(_templateObject3(), _spacing.default.s1);

DialogButtonGroup.displayName = 'DialogButtonGroup';

var DisplayValue = _styledComponents.default.div(_templateObject4());

DisplayValue.displayName = 'DisplayValue';

var TimeValue = _styledComponents.default.span(_templateObject5());

TimeValue.displayName = 'TimeValue';
var TwentyFourHourValue = (0, _styledComponents.default)(TimeValue)(_templateObject6(), _vars.default.fontStackBold);
TwentyFourHourValue.displayName = 'TwentyFourHourValue';
var TwelveHourValue = (0, _styledComponents.default)(TimeValue)(_templateObject7());
TwelveHourValue.displayName = 'TwelveHourValue';

var formatTimePart = function formatTimePart(v) {
  return v.toString().padStart(2, '0');
};

var convertHours = function convertHours(hour) {
  if (hour === 0) return 12;
  return hour > 12 ? hour - 12 : hour;
};

var TimeOverlay = function TimeOverlay(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      onHide = _ref.onHide,
      hourIncrements = _ref.hourIncrements,
      minuteIncrements = _ref.minuteIncrements,
      min = _ref.min,
      max = _ref.max,
      GA = _ref.GA;

  var sanitizeValue = function sanitizeValue(unsanitizedValue) {
    return (0, _getBoundedValue.default)(unsanitizedValue, (0, _durationToMilliseconds.default)(min), (0, _durationToMilliseconds.default)(max));
  };

  var _useState = (0, _react.useState)(sanitizeValue((0, _durationToMilliseconds.default)(value))),
      internalValue = _useState[0],
      setInternalValue = _useState[1];

  var setHandler = function setHandler(unitValue, unit) {
    var proposedDate = new Date(internalValue);

    if (unit === 'minutes') {
      proposedDate.setUTCMinutes((0, _roundTo.default)(minuteIncrements)((0, _getBoundedValue.default)(unitValue, 0, 59)));
    }

    if (unit === 'hours') {
      proposedDate.setUTCHours((0, _roundTo.default)(hourIncrements)((0, _getBoundedValue.default)(unitValue, 0, 23)));
    }

    var appliedValue = sanitizeValue(proposedDate.getTime());
    setInternalValue(appliedValue);
  };

  var _millisecondsToDurati = (0, _millisecondsToDuration.default)(internalValue),
      hours = _millisecondsToDurati.hours,
      minutes = _millisecondsToDurati.minutes;

  return _react.default.createElement(Overlay, null, _react.default.createElement(Content, null, _react.default.createElement(_UnitInput.default, {
    unit: "hours",
    value: hours,
    onChange: function onChange(i) {
      return setHandler(i, 'hours');
    },
    increment: hourIncrements,
    min: min.hours,
    max: max.hours
  }), _react.default.createElement(_UnitInput.default, {
    unit: "minutes",
    value: minutes,
    onChange: function onChange(i) {
      return setHandler(i, 'minutes');
    },
    increment: minuteIncrements,
    min: hours === min.hours ? min.minutes : 0,
    max: hours === max.hours ? max.minutes : 59
  })), _react.default.createElement(DialogButtonGroup, null, _react.default.createElement(_OutlineButton.default, {
    type: "button",
    onClick: function onClick() {
      onHide();

      if (GA) {
        (0, _reactGa.event)({
          category: GA.category,
          action: GA.action + " (Cancel)"
        });
      }
    }
  }, "Cancel"), _react.default.createElement(DisplayValue, null, _react.default.createElement(TwentyFourHourValue, null, formatTimePart(hours), ":", formatTimePart(minutes)), _react.default.createElement(TwelveHourValue, null, convertHours(hours), ".", formatTimePart(minutes), hours > 11 ? 'pm' : 'am', ' ')), _react.default.createElement(_BrandButton.default, {
    type: "button",
    onClick: function onClick() {
      onChange({
        hours: hours,
        minutes: minutes
      });
      onHide();

      if (GA) {
        (0, _reactGa.event)({
          category: GA.category,
          action: GA.action + " (Apply)",
          label: hours + " hrs " + minutes + " mins"
        });
      }
    },
    "data-e2e": "time-apply"
  }, "Apply")));
};

var timeShape = (0, _propTypes.shape)({
  hours: _propTypes.number,
  minutes: _propTypes.number
});
TimeOverlay.propTypes = {
  value: timeShape.isRequired,
  min: timeShape.isRequired,
  max: timeShape.isRequired,
  onChange: _propTypes.func.isRequired,
  onHide: _propTypes.func.isRequired,
  minuteIncrements: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.number), _propTypes.number]),
  hourIncrements: _propTypes.number,
  GA: (0, _propTypes.shape)({
    category: _propTypes.string,
    action: _propTypes.string
  })
};
TimeOverlay.defaultProps = {
  minuteIncrements: 1,
  hourIncrements: 1,
  GA: undefined
};
var _default = TimeOverlay;
exports.default = _default;